import LazyImage from './LazyImage.jsx';

const ShopItem = ({ url, name }) => {
  return (
    <div className="group relative break-inside-avoid mb-4">
      <div>
        <LazyImage
          src={url}
          alt={name}
          className="w-full h-full object-cover"
        />
      </div>
      <div
        className="absolute inset-0
                bg-black/60
                opacity-0
                group-hover:opacity-100
                transition-opacity
                duration-300
                backdrop-filter
                backdrop-saturate-100
                group-hover:backdrop-saturate-200
              "
      >
        <div className="absolute inset-0  flex flex-col justify-center  text-center">
          <span className="font-nunito font-extrabold text-3xl text-white">
            {name}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ShopItem;
